import React from "react";

// R5 — Weekly Digest (Telegram) preview. Data from GET /v1/bo/digest (see
// backoffice.routes.js -> models.digest.getDigest), assembled from R1/T4/T6.
// This only RENDERS the message text for an admin to review and copy — there is no
// Telegram bot token/channel wired up in this codebase, so nothing is sent
// automatically. See libs/digest.js for why that's a deliberate P1 boundary.
let churnDigestSection = {
  name: "Digest Mingguan",
  slug: "churnDigest",
  visible: true,
  singularName: "churnDigest",
  crud: true,
  endpoint: "/v1/bo/digest",
  updateLabel: "churnDigest",
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  noNeedSearch: true,
  noNeedRefresh: false,
  add: false,
  update: false,
  edit: false,
  exportToCsv: false,
  fields: [
    {
      label: "Isi Digest (salin manual ke Telegram)",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (
        <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", margin: 0 }}>
          {row && row.digest_text ? row.digest_text : "-"}
        </pre>
      ),
    },
  ],
};

export default [churnDigestSection];
